import React, { Fragment, memo } from "react";
import { Flex, Text, SimpleGrid } from "@chakra-ui/react";
import { getAlohaSupportData } from "@/constants/alohainfo-contants";
import SupportItemComponent from "./item";
export default memo(function ProjectSupportedComponent() {
   const list = getAlohaSupportData();
   return (
      <Flex flexDir={"column"} bgColor="#F5FAFC"  alignItems="center"
      
       pt={{ base: "50px", BREAK_PAD:"85px",BREAK_LPC: "120px" }}
       pb={{ base: "60px", BREAK_PAD:"90px",BREAK_LPC: "120px" }}>
         <Text
            maxW={{ base: "90%", BREAK_PAD: "80%", BREAK_LPC: "70%" }}
            mx={"auto"}
            fontSize={{ base: 24, BREAK_LPC: 34 }}
            fontFamily={{ base: "Arial-BoldMT", BREAK_LPC: "Arial" }}
            textAlign="center">
            Some of NFT Projects Supported by Our Bots
         </Text>
         <SimpleGrid
          zIndex={1}
            w={{ base: "90%", BREAK_PAD: "740px", BREAK_LPC: "960px", BREAK_PC: "1280px" }}
            columns={{ base: 1, BREAK_LPC: 3 }}
            gridGap={"20px"}
            mx={"auto"}
            mt={{ base: "30px", BREAK_PAD: "45px", BREAK_LPC: "70px"}}>
            {list.map((item, index) => {
               return (
                  <Fragment key={index}>
                     <SupportItemComponent item={item} />
                  </Fragment>
               );
            })}
         </SimpleGrid>
      </Flex>
   );
});
